/* Progressive enhancement. No product pricing, inventory or checkout is mocked here. */
(() => {
 'use strict';
 const storageKey = 'xyra:wishlist:v1';
 let items = [];
 const locale=document.documentElement.lang||'de';
 let config={};try{config=JSON.parse(document.getElementById('XyraConfig')?.textContent||'{}');}catch(_){}
 const root=config.root||'/';
 const localized=new Map();
 const sameProduct=(item,button)=>item.id&&button.dataset.productId?String(item.id)===button.dataset.productId:item.handle===button.dataset.handle;
 const productUrl=handle=>root.replace(/\/?$/,'/')+'products/'+encodeURIComponent(handle);
 const isProduct = item => item && typeof item.handle === 'string' && /^[a-z0-9-]+$/.test(item.handle) && typeof item.title === 'string' && typeof item.url === 'string';
 try { const data = JSON.parse(localStorage.getItem(storageKey) || '[]'); if (Array.isArray(data)) items = data.filter(isProduct).slice(0,100); } catch (_) { /* Privacy modes may block storage. */ }
 const safeUrl = (url,image=false) => {
  try { const value = new URL(url,location.origin); if (!['http:','https:'].includes(value.protocol)) return ''; if (!image && value.origin!==location.origin) return ''; return value.href; } catch (_) { return ''; }
 };
 let returnFocus;
 const dialog = document.getElementById('XyraWishlist');
 const status = document.getElementById('XyraStatus');
 function persist(next) {
  try { localStorage.setItem(storageKey,JSON.stringify(next));items=next;return true; }
  catch (_) { if(status) status.textContent=dialog?.dataset.storageError || '';return false; }
 }
 function refresh() {
  document.querySelectorAll('[data-wishlist-save]').forEach(button=>{
   const saved=items.some(item=>sameProduct(item,button));
   const cached=items.find(item=>sameProduct(item,button));
   if(cached)localized.set(cached.handle,{title:button.dataset.title,url:button.dataset.url,locale});
   button.setAttribute('aria-pressed',String(saved));
   const label=saved?button.dataset.removeLabel:button.dataset.saveLabel;
   if(label){button.setAttribute('aria-label',`${label}: ${button.dataset.title}`);button.title=label;const text=button.querySelector('span');if(text)text.textContent=label;}
  });
  document.querySelectorAll('[data-wishlist-count]').forEach(node=>node.textContent=String(items.length));
  if(!dialog)return;
  const list=dialog.querySelector('[data-wishlist-items]');list.replaceChildren();
  dialog.querySelector('[data-wishlist-empty]').hidden=items.length>0;
  for(const item of items){
   const row=document.createElement('div');row.className='wishlist__row';
   const image=document.createElement('img');image.loading='lazy';image.alt='';image.width=75;image.height=90;
   const imageUrl=safeUrl(item.image,true);if(imageUrl)image.src=imageUrl;
   const current=localized.get(item.handle);
   const link=document.createElement('a');link.href=safeUrl(current?.url||productUrl(item.handle))||root;link.textContent=current?.title||item.title;
   const remove=document.createElement('button');remove.type='button';remove.dataset.wishlistRemove=item.handle;remove.setAttribute('aria-label',`${dialog.dataset.removeLabel}: ${item.title}`);remove.textContent='\u00d7';
   row.append(image,link,remove);list.append(row);
  }
 }
 let hydration=0;
 async function hydrate(){
  const run=++hydration;
  const queue=items.filter(item=>!localized.has(item.handle));
  const worker=async()=>{while(queue.length && run===hydration){
   const item=queue.shift();const controller=new AbortController();const timer=setTimeout(()=>controller.abort(),6000);
   try{
    const response=await fetch(productUrl(item.handle)+'.js',{headers:{Accept:'application/json'},signal:controller.signal});
    if(!response.ok)continue;const product=await response.json();
    if(typeof product.title==='string' && typeof product.handle==='string' && /^[a-z0-9-]+$/.test(product.handle))localized.set(item.handle,{title:product.title,url:productUrl(product.handle),locale});
   }catch(_){/* A network failure must not delete a saved item. */}finally{clearTimeout(timer);}
  }};
  await Promise.all(Array.from({length:Math.min(4,queue.length)},worker));
  if(run===hydration && dialog?.open)refresh();
 }
 document.addEventListener('click',event=>{
  const save=event.target.closest('[data-wishlist-save]');
  if(save){
   event.preventDefault();
   const {handle,title,url,image,productId}=save.dataset;
   if(!isProduct({handle,title,url}))return;
   const exists=items.some(item=>sameProduct(item,save));
   const next=exists?items.filter(item=>!sameProduct(item,save)):[...items,{handle,title,url,image,id:productId,locale}].slice(-100);
   if(persist(next)){refresh();if(status)status.textContent=exists?dialog?.dataset.removedMessage||'':dialog?.dataset.savedMessage||'';}return;
  }
  const remove=event.target.closest('[data-wishlist-remove]');
  if(remove){if(persist(items.filter(item=>item.handle!==remove.dataset.wishlistRemove))){refresh();dialog?.querySelector('[data-close-dialog]')?.focus();}return;}
  const opener=event.target.closest('[data-open-wishlist]');
  if(opener&&dialog&&typeof dialog.showModal==='function'){
   event.preventDefault();returnFocus=opener;refresh();if(!dialog.open)dialog.showModal();document.body.classList.add('modal-open');hydrate();
  }
 });
 dialog?.addEventListener('close',()=>{document.body.classList.toggle('modal-open',Boolean(document.querySelector('dialog[open]')));returnFocus?.focus({preventScroll:true});});
 window.addEventListener('storage',event=>{if(event.key!==storageKey)return;try{const data=JSON.parse(event.newValue||'[]');items=Array.isArray(data)?data.filter(isProduct).slice(0,100):[];refresh();}catch(_){}});
 // Long menus and large text use the existing accessible mobile drawer.
 let frame=0;
 function fitHeader(){
  frame=0;
  const header=document.querySelector('[data-header]'),nav=header?.querySelector('.desktop-nav'),left=header?.querySelector('.header-left');
  if(!header||!nav||!left)return;
  header.removeAttribute('data-compact');
  if(window.innerWidth>=1400 && nav.scrollWidth>left.clientWidth+2)header.dataset.compact='true';
  const menu=header.querySelector('[data-menu]');
  if(window.innerWidth>=1400 && header.dataset.compact!=='true' && menu?.open){menu.open=false;document.body.classList.remove('menu-open');}
 }
 function schedule(){if(!frame)frame=requestAnimationFrame(fitHeader);}
 window.addEventListener('resize',schedule,{passive:true});
 document.fonts?.ready.then(schedule);
 document.addEventListener('shopify:section:load',()=>{refresh();schedule();});
 document.addEventListener('xyra:catalog:updated',refresh);
 refresh();schedule();
})();

/* Preserve space below the footer only when an actual Shopify preview bar exists. */
(() => {
 let previous = -1;
 const seen = new WeakSet();
 const observer = typeof ResizeObserver==='undefined'?null:new ResizeObserver(measure);
 function measure(){
   let inset=0;
   document.querySelectorAll('#preview-bar-iframe,#ShopifyPreviewBar,#shopify-preview-bar,[data-shopify-preview-bar]').forEach(node=>{
     if(!seen.has(node)){seen.add(node);observer?.observe(node);}
     const r=node.getBoundingClientRect(),s=getComputedStyle(node);
     if(s.position==='fixed' && s.display!=='none' && r.width>innerWidth*.5 && r.height>0 && r.height<240 && r.bottom>=innerHeight-2)inset=Math.max(inset,Math.ceil(r.height));
   });
   if(inset!==previous){previous=inset;document.documentElement.style.setProperty('--xyra-preview-inset',`${inset}px`);}
 }
 const mutations=new MutationObserver(measure);mutations.observe(document.body,{childList:true,subtree:true});
 window.addEventListener('resize',measure,{passive:true});measure();
})();
